// extracted by mini-css-extract-plugin
module.exports = {"tabUnselected":"Tab_tabUnselected__3EeUZ","content":"Tab_content__kO4H0","text":"Tab_text__3hT4d","indicator":"Tab_indicator__3iU5s","tabSelected":"Tab_tabSelected__1OfCW"};